import Cookies from 'js-cookie';
import { Experiments, Buckets } from '../constants';

export const isMyCarsReskinFixed = (): boolean => Cookies?.get?.(Experiments.MY_CARS_RESKIN) === Buckets.CONTROL_FIXED;
